import { nextTick, ref } from "vue";

export function useEditableRows() {
  const editingRow = ref(null);
  let snapshot = null;

  function isEditing(row) {
    return editingRow.value === row;
  }

  function isEditingAny() {
    return editingRow.value !== null;
  }

  function startEdit(row, { focusRef, scrollRef } = {}) {
    snapshot = { ...row };
    editingRow.value = row;
    if (focusRef || scrollRef) {
      nextTick(() => {
        focusRef?.value?.focus();
        scrollRef?.value?.scrollToBottom();
      });
    }
  }

  function cancelEdit(row, { onDiscardNew } = {}) {
    if (row?.isNew && typeof onDiscardNew === "function") {
      onDiscardNew(row);
    } else if (snapshot) {
      Object.assign(row, snapshot);
    }
    snapshot = null;
    editingRow.value = null;
  }

  function confirmEdit(row, { validate, focusRef } = {}) {
    if (typeof validate === "function" && !validate(row)) {
      return false;
    }
    if (row) row.isNew = false;
    snapshot = null;
    editingRow.value = null;
    if (focusRef) {
      nextTick(() => setTimeout(() => focusRef.value?.focus(), 0));
    }
    return true;
  }

  function createNewRow(factory) {
    return { ...factory(), isNew: true };
  }

  return {
    editingRow,
    isEditing,
    isEditingAny,
    startEdit,
    cancelEdit,
    confirmEdit,
    createNewRow,
  };
}
